
export const GET_MEMBER_CARDS_START = "GET_MEMBER_CARDS_START";
export const GET_MEMBER_CARDS_SUCCESS = "GET_MEMBER_CARDS_SUCCESS";
export const GET_MEMBER_CARDS_FAIL = "GET_MEMBER_CARDS_FAIL";
export const EDIT_MEMBER_CARD_INFO = "EDIT_MEMBER_CARD_INFO";
export const EDIT_MEMBER_CARD_INFO_SET_LOADING = "EDIT_MEMBER_CARD_INFO_SET_LOADING";